/**
 * @generated SignedSource<<d72d49ee035514016288c416e33c64e2>>
 * @relayHash 9d6023463f6a0708d8446bcb01f1cdd7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e45c674fe96bfd258106706f4fe71f3437a51e8e47957de932920dc072950198

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardSettingsSwitcherQuery$variables = {
  boardId: string;
};
export type BoardSettingsSwitcherQuery$data = {
  readonly jira: {
    readonly jiraBoard: {
      readonly board?: {
        readonly " $fragmentSpreads": FragmentRefs<"SettingsContainer_board">;
      } | null;
    } | null;
  } | null;
};
export type BoardSettingsSwitcherQuery = {
  response: BoardSettingsSwitcherQuery$data;
  variables: BoardSettingsSwitcherQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "boardId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "BoardSettingsSwitcherQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "jiraBoard",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "SettingsContainer_board"
                        }
                      ],
                      "type": "JiraBoard"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "board"
                  }
                ],
                "type": "JiraBoard"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BoardSettingsSwitcherQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "jiraBoard",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "defaultNavigationItem",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          }
                        ],
                        "type": "JiraNavigationItem",
                        "abstractKey": "__isJiraNavigationItem"
                      },
                      (v3/*: any*/)
                    ]
                  }
                ],
                "type": "JiraBoard"
              },
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e45c674fe96bfd258106706f4fe71f3437a51e8e47957de932920dc072950198",
    "metadata": {},
    "name": "BoardSettingsSwitcherQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ccd1f981e19df1b9eaa04d86c1afd931";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
